import { formatNumber, CountryCode } from 'libphonenumber-js'
import { PhoneHelper } from '@Helpers/phone'

export const formatPhone = function (phone: string) {
  if (!phone) return ''
  let iso: CountryCode = PhoneHelper.selectCountryWithDialCode(phone)
  return formatNumber(phone, iso, 'National')
}